// 해시 라우팅(#/… 고정 — DESIGN §5). 토큰이 없으면 어느 주소든 로그인 화면만 보인다(데이터 노출 0)
import { useEffect } from "react";
import { clearSession, useToken } from "./auth";
import { setHandlers, startEngine, stopEngine } from "./data/store";
import { Dashboard } from "./screens/Dashboard";
import { Login } from "./screens/Login";
import { Register } from "./screens/Register";
import { Admin } from "./screens/Admin";
import { Board } from "./screens/Board";
import { SheetHost } from "./screens/sheets";
import { Soon } from "./screens/Soon";
import { Students } from "./screens/Students";
import { Week } from "./screens/Week";
import { Today } from "./screens/Today";
import { go, useRoute } from "./ui/hooks";
import { Toasts, toast } from "./ui/parts";
import { Shell } from "./ui/Shell";

setHandlers({
  unauthorized: () => {
    stopEngine(false);
    clearSession();
    go("login");
    toast("로그인이 만료됐습니다. 다시 로그인하세요.", { tone: "error" });
  },
  notify: (msg, tone) => toast(msg, { tone: tone === "error" ? "error" : "info" }),
});

export function App() {
  const route = useRoute();
  const token = useToken();

  useEffect(() => {
    if (token) void startEngine(token);
  }, [token]);

  useEffect(() => {
    if (!token && route.name !== "login") go("login");
    if (token && route.name === "login") go("");
  }, [token, route.name]);

  if (!token || route.name === "login") {
    return (
      <>
        <Login />
        <Toasts />
      </>
    );
  }

  let screen;
  switch (route.name) {
    case "":
      screen = <Dashboard />;
      break;
    case "register":
      screen = <Register route={route} />;
      break;
    case "today":
      screen = <Today route={route} />;
      break;
    case "week":
      screen = <Week />;
      break;
    case "students":
      screen = <Students route={route} />;
      break;
    case "board":
      screen = <Board />;
      break;
    case "admin":
      screen = <Admin />;
      break;
    default:
      screen = <Soon name={route.name} />;
  }
  return (
    <>
      <Shell route={route}>{screen}</Shell>
      <SheetHost />
      <Toasts />
    </>
  );
}
